export default __webpack_public_path__ + "static/media/greyCar.5123546a.svg";